import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
  // Each locale JSON module exposes its translation tree as the default export.
  const locales = import.meta.glob<{ default: Record<string, any> }>("./locales/*.json", { eager: true });
  /** Locale code (file basename, e.g. 'en') -> translation message tree */
  const messages: Record<string, Record<string, any>> = {};
  for (const path in locales) {
    const matched = path.match(/([A-Za-z0-9-_]+)\.json$/i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales[path].default;
    }
  }
  return messages;
}

export default createI18n({
  legacy: false,
  locale: import.meta.env.VITE_I18N_LOCALE || "en",
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
});
